/**
 * Custom Hook: useCourseAccess
 * Manages course access validation, enrollment checks, and access state
 */

import { useState, useEffect } from 'react';
import { checkCourseAccess, registerDevice } from '../services/lmsAccessControl';

export const useCourseAccess = (courseId, studentData) => {
  const [loading, setLoading] = useState(true);
  const [accessStatus, setAccessStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!courseId || !studentData) {
      setLoading(false);
      return;
    }

    checkAccess();
  }, [courseId, studentData]);

  const checkAccess = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await checkCourseAccess(courseId, studentData);
      setAccessStatus(result);

      // Auto-register device if access is granted
      if (result.hasAccess) {
        await registerDevice(studentData.phone, courseId, 'web');
      }
    } catch (err) {
      setError(err.message);
      setAccessStatus({ hasAccess: false, reason: 'error', message: err.message });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    accessStatus,
    error,
    hasAccess: accessStatus?.hasAccess || false,
    recheckAccess: checkAccess
  };
};
